/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_BusinessInputs */

const en_directory_launch_filter_business = /** @type {(inputs: Directory_Launch_Filter_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const zh_directory_launch_filter_business = /** @type {(inputs: Directory_Launch_Filter_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商业`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Directory_Launch_Filter_BusinessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_business = /** @type {((inputs?: Directory_Launch_Filter_BusinessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_BusinessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_business(inputs)
	return zh_directory_launch_filter_business(inputs)
});
export { directory_launch_filter_business as "directory.launch.filter_business" }